module.exports = __webpack_public_path__ + "img/2.1.62b3e256.jpg";